import { RACES } from './constants';

export const isString = value => typeof value === 'string';

export const isNumber = value => typeof value === 'number';

export function safeParseToNumber(value) {
  if (isNumber(value)) {
    return value;
  }

  if (isString(value)) {
    return parseInt(value, 10);
  }

  return value;
}

export function getRace(raceId) {
  return RACES.find(({ id }) => id === raceId);
}

export function getRacesWeights(races) {
  const amount = races.reduce((acc, value) => acc + value, 0);

  return races.map(race => race / amount);
}

export function parseGenome(genome) {
  const padding = 3;
  const [
    head,
    eyes,
    horns,
    body,
    wings,
    arms,
    legs,
    tail,
    spike,
    pattern,
  ] = genome
    .map(safeParseToNumber)
    .reduce((acc, gene) => {
      const lastGroup = acc.pop();

      if (lastGroup.length < padding) {
        return [...acc, [...lastGroup, gene]];
      }

      return [...acc, lastGroup, [gene]];
    }, [[]])
    .map(([race, type, level], index) => ({
      race,
      type,
      level,
      bodyPartType: index,
    }));

  return Object.entries({
    head,
    eyes,
    horns,
    body,
    wings,
    arms,
    legs,
    tail,
    spike,
    pattern,
  }).reduce((acc, [key, value]) => ({
    ...acc,
    [key]: {
      ...value,
      bodyPartName: key,
    },
  }), {});
}
